<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .reset-wrapper.reg-pg
        img(src='/images/reg-banner.jpg')
        h5.text-center.pt-3.yellow
          b {{ $t('ui.register_title') }}
        form
          .step-reg
            .ewstep-reg.rstepbox.s1(:class="{'active': step == 1}") 1
            .ewstep-reg.rstepbox.s2(:class="{'active': step == 2}") 2
          .pt-0.ewstep-regbox.active(v-if="step == 1")
            .mb-3
              label.col-form-label {{ $t("ui.full_phone") }}
              //- .d-flex.gap-2
                select.form-control.w-auto.prefix(v-model="prefix")
                  option(value="010") 010
                  option(value="011") 011
                  option(value="012") 012
                  option(value="013") 013
                  option(value="014") 014
                  option(value="015") 015
                  option(value="016") 016
                  option(value="017") 017
                  option(value="018") 018
                  option(value="019") 019
              input.form-control#signUpUsername(type="text" placeholder="9471427" v-model.trim="$v.signUpUsername.$model" @keypress="$helpers.onlyNumber")
              //- .note Valid phone number ONLY eg: 0109471427, no spacing
              .note.error.w-100(v-if="!$v.signUpUsername.alphaNum && $v.signUpUsername.$dirty && $v.signUpUsername.required")
                small.text-danger.form-text {{ $t('message.alphanumeric_char') }}
              .note.error.w-100(v-else-if="$v.signUpUsername.$dirty && !$v.signUpUsername.required")
                small.text-danger.form-text {{ $t('message.list.phoneRequired') }}
              .note.error.w-100(v-else-if="$v.signUpUsername.$dirty && !$v.signUpUsername.minLength && $v.signUpUsername.$alphaNum")
                small.text-danger.form-text {{ $t('message.min_length') }}
              .note.error.w-100(v-else)
                div(:class="[$v.signUpUsername.$dirty && $v.signUpUsername.$error ? 'text-danger' : '']") {{ $t('ui.phone_tips') }}
            .mb-3
              label.col-form-label {{ $t("ui.password_signup") }}
              input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.password')" v-model.trim="$v.signUpPassword.$model")
              .note.error.w-100
                div(:class="[$v.signUpPassword.$dirty && $v.signUpPassword.$error ? 'text-danger' : '']" v-html="$t('ui.password_tips')")
            .mb-3
              label.col-form-label {{ $t("ui.full_referral") }}
              input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.referral_code')+'('+$t('ui.optional')+')'" v-model="referral_code" :disabled="disabledRef")
            .reg-btn.pb-3.text-center
              a(href='javascript:void(0)' @click.stop="signUp" v-if="!loading")
                img(src='/images/register.png')
              a(v-if="loading")
                i.fas.fa-duotone.fa-spinner.fa-spin-pulse
          .pt-0.ewstep-regbox.active(v-if="step == 2")
            .mb-3
              label.col-form-label.text-center {{ $t("ui.verification_number") }}
              .input-group.mb-3
                input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                .input-group-append
                  button.resend.btn.btn-outline-secondary.disabled-grey(v-if="tacCountDown") {{ tacDisplay }}
                  button.resend.btn.btn-outline-secondary(v-if="!tacCountDown" type='button' @click.prevent="resendTacCode") {{ $t("ui.resend") }}
            .text-center.mb-3(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
            .text-center
              button.btn-submit(type='button' @click.prevent="tacValidate" :disabled="loading") {{ $t('ui.next') }}
            .font-weight-bold.text-danger.mt-3.text-center.pointer(v-html="$t('ui.tac_tips')" @click="openChat")
            //- .text-center.pt-3.pb-3
              a(href='javascript:void(0)' @click="$helpers.openModal('#tac')")
                .glow-button.text-capitalize.pointer {{$tc('ui.tac_tips2')}}

  //- div
    #modal-register01.modal.fade(tabindex='-1' aria-hidden='true')
      .modal-dialog.modal-dialog-centered
        .modal-content
          .modal-header-cus-banner
            img(src='assets/img/banner-reg.jpg')
            h5.text-center.pt-3
              b {{ $t('ui.register_title') }}
          form
            .modal-body.pt-0
              .step-reg
                .rstepbox.s1.active 1
                .rstepbox.s2 2
              .mb-3
                label.col-form-label {{ $t("ui.full_phone") }}
                .d-flex.gap-2
                  select.form-control.w-auto(v-model="prefix")
                    option(value="010") 010
                    option(value="011") 011
                    option(value="012") 012
                    option(value="013") 013
                    option(value="014") 014
                    option(value="015") 015
                    option(value="016") 016
                    option(value="017") 017
                    option(value="018") 018
                    option(value="019") 019
                  input.form-control#signUpUsername(type="text" placeholder="9471427" v-model.trim="$v.signUpUsername.$model" @keypress="$helpers.onlyNumber")
                .error.w-100(v-if="!$v.signUpUsername.alphaNum && $v.signUpUsername.$dirty && $v.signUpUsername.required")
                  small.text-danger.form-text {{ $t('message.alphanumeric_char') }}
                .error.w-100(v-else-if="$v.signUpUsername.$dirty && !$v.signUpUsername.required")
                  small.text-danger.form-text {{ $t('message.list.phoneRequired') }}
                .error.w-100(v-else-if="$v.signUpUsername.$dirty && !$v.signUpUsername.minLength && $v.signUpUsername.$alphaNum")
                  small.text-danger.form-text {{ $t('message.min_length') }}
                .error.w-100(v-else)
                  div(:class="[$v.signUpUsername.$dirty && $v.signUpUsername.$error ? 'text-danger' : 'text-muted']") {{ $t('ui.phone_tips') }}
              .mb-3
                label.col-form-label {{ $t("ui.password_signup") }}
                input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.password')" v-model.trim="$v.signUpPassword.$model")
                .error.w-100
                  div(:class="[$v.signUpPassword.$dirty && $v.signUpPassword.$error ? 'text-danger' : 'text-muted']" v-html="$t('ui.password_tips')")
                  //- small.form-text(:class="[$v.signUpPassword.$dirty && $v.signUpPassword.$error ? 'text-danger' : 'text-muted']") {{ $t('ui.password_tips') }}
              div
                label.col-form-label {{ $t("ui.full_referral") }}
                input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.referral_code')+'('+$t('ui.optional')+')'" v-model="referral_code" :disabled="disabledRef")
                //- ValidateResult(:value="$v.referral_code" :name="$t('ui.referral_code')")
              //- .input-group.mb-4
                label.mb-1.small-top {{ $t("ui.affiliate_code") }}
                input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.affiliate_code')+'('+$t('ui.optional')+')'" v-model.trim="$v.affiliate_code.$model" :disabled="disabledAffi")
                ValidateResult(:value="$v.affiliate_code" :name="$t('ui.affiliate_code')")
              //- .input-group.mb-2(v-if="!feedback.success")
                .error.w-100
                  small.form-text.text-danger {{ $t(feedback.status) }}
            .modal-footer.s2
              .text-center
                button.btn-submit(type='button' @click.stop="signUp" :disabled="loading") {{ $t('ui.next') }}
    #modal-register02.modal.fade(tabindex='-1' aria-hidden='true')
      .modal-dialog.modal-dialog-centered
        .modal-content
          .modal-header-cus-banner
            img(src='assets/img/banner-reg.jpg')
            h5.text-center.pt-3
              b {{ $t('ui.register_title') }}
          form
            .modal-body.pt-0
              .step-reg
                .rstepbox.s1 1
                .rstepbox.s2.active 2
              .verification.p-3.mb-1
                .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.verification_number") }}
                .text-center.mb-2(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
                .d-flex.justify-content-between.px-1
                  .input-group
                    input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                    .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.disabled-grey(v-if="tacCountDown")
                      | {{ tacDisplay }}
                    .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center(v-else @click="resendTacCode")
                      | {{ $t("ui.resend") }}
                    //- span#timer (180)
                //- .text-center {{$tc('ui.admin_open')}}
                //- .d-flex.justify-content-between.px-1.mb-2
                //-   ValidateResult(:value="$v.tacCode" :name="$t('ui.tac_code')")
                //- .text-center.text-danger(v-if="tacCountDown") {{ $t('message.tac_countdown', {countdown : tacDisplay})}}
                //- .text-center.px-lg-3(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
                //- .text-center(v-if="!tacCountDown") {{ $t("message.tac_tooltips1") }}
              //- div.text-center.px-lg-4 {{$tc('ui.admin_open')}}
              //- .d-flex.justify-content-between.mb-2.pointer(@click="toggleCheck")
                .mr-2
                  input(type="checkbox" name="" value="" v-model="emailChecked" )
                .accept {{$tc('ui.newsletter')}}
              //- div.mt-2(v-if="emailChecked")
                .input-group.mb-2
                  label.mb-1.small-top {{ $t("ui.email") }}
                  input.form-control(type="text" autocomplete="off" :placeholder="$t('ui.email')" v-model.trim="$v.userEmail.$model")
                  ValidateResult(:value="$v.userEmail" :name="$t('ui.email')")
            .modal-footer.s2
              .text-center
                button.btn-submit(type='button' @click.stop="tacValidate" :disabled="loading") {{ $t('ui.next') }}
              .font-weight-bold.text-danger.mt-3.text-center {{$tc('ui.tac_tips')}}
              .text-center.mt-2
                .glow-button.text-capitalize.pointer(data-bs-dismiss="modal" @click="$helpers.openModal('#modal-banner-0')") {{$tc('ui.tac_tips2')}}
    //- #modal-register03.modal(tabindex="-1" role="dialog")
      .modal-dialog.modal-dialog-centered.modal-form(role='document')
        .modal-content
          .modal-body.p-4.p-md-5.round-border-bottom
            .user-wrap
              i.fas.fa-user
            .text-uppercase.text-center.mb-3.text-login-modal {{ $t("ui.register") }}
            .step.d-flex.justify-content-center.mb-3.mb-lg-4
              .circle 1
              .circle 2
              .circle.active 3
            .account-success.text-center.mt-lg-1.mb-3
              | {{ $t('ui.signupform.account_success_first') }}
              br
              span.text-success {{ $t('ui.signupform.account_success_second') }}
            form
              //- a(v-if="isIOS" :href='$store.getters.iosURL')
              //-   .btn.btn-block.btn-main.mt-2.mt-lg-3.btn-purple {{ $t("ui.downloadgame") }}
              //- a(v-else :href='$store.getters.androidURL')
              //-   .btn.btn-block.btn-main.mt-2.mt-lg-3.btn-purple {{ $t("ui.downloadgame") }}
              a(href="javascript:void(0);" @click="login")
                .btn.btn-block.btn-main.mt-2.mt-lg-3.btn-purple {{ $t("ui.deposit_now") }}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import { required, minLength, maxLength, alphaNum, email } from 'vuelidate/lib/validators'
import ValidateResult from "@/library/ValidateResult"
import _ from "lodash";

export default {
  components: {
    ValidateResult
  },
  props:{
    tempAccName:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      prefix: "010",
      signUpUsername: "",
      signUpPassword: "",
      referral_code: "",
      affiliate_code: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      conditionChecked: false,
      isTacPanel: false,
      tacCode:"",
      disabledRef: false,
      disabledAffi: false,
      isIOS: false,
      tacTimer: null,
      tacCountDown: false,
      tacDisplay: "",
      ch: "",
      cm: "",
      pp: "",
      userEmail: "",
      emailChecked: false,
      currentPath:"",
      step: 1,
      metaData: []
      // refCode:"",
    };
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed: {
    getAnnAfterLog() {
      return this.$store.state.user.annAfterLog;
    },
    getLanguage() {
      return this.$store.getters.language || "en";
    }
  },
  validations: {
    signUpUsername: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      alphaNum
    },
    signUpPassword: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      valid: function(value){
        const containsAlphabet = /[A-Za-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        return containsAlphabet && containsNumber
      }
    },
    // referral_code: {
    //   minLength: minLength(6),
    //   maxLength: maxLength(6)
    // },
    userEmail:{
      email,
      required: function(){
        return this.emailChecked == true && (this.userEmail == "" || this.userEmail == null) ? false : true
      }
    },
    // affiliate_code:{
    //   alphaNum
    // },
    // conditionChecked: {
    //   required(val) {
    //     return val;
    //   }
    // },
    tacCode: {
      required(val) {
        return this.isTacPanel ? required(val) : true;
      }
    },
  },
  destroyed() {
    this.disabledRef = false
    this.disabledAffi = false
    this.clearCountDown();
    this.tacCountDown = false
  },
  mounted() {
    var username = this.$store.state.user.tempName;
    var password = this.$store.state.user.tempPass;
    if(this.$store.state.user.tempName && this.$store.state.user.tempPass){
      this.step = 2
    }

    this.currentPath = this.$router.currentRoute.path
    if(!_.isEmpty(this.$route.query)){
      if(this.$route.query.ref){
        this.referral_code = this.$route.query.ref;
        this.disabledRef = true
      }
      if(this.$route.query.affiliatecode){
        this.affiliate_code = this.$route.query.affiliatecode;
        this.disabledAffi = true
      }
      if(this.$route.query.ch){
        this.ch = this.$route.query.ch
      }
      if(this.$route.query.cm){
        this.cm = this.$route.query.cm
      }
      if(this.$route.query.pp){
        this.pp = this.$route.query.pp
      }
      
    }
    $("#signUpUsername").trigger('focus')
    // this.getSeo()
    window.scroll(0,0)
  },
  methods: {
    openChat(){
      LiveChatWidget.call("maximize");
    },
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    toggleCheck(){
      this.emailChecked = !this.emailChecked
      if(this.emailChecked == false){
        this.userEmail = ""
      }
    },
    countDown(){
      var vm = this
      var timer = 180000
      this.tacCountDown = true
      this.tacTimer = setInterval(() => {
        if(timer > 0){
          timer -= 1000;
          this.tacDisplay= vm.$moment.utc(timer).format('mm:ss');
        }else{
          this.clearCountDown();
          vm.tacCountDown = false
          this.tacDisplay = ""
        }
      }, 1000)
    },
    clearCountDown(){
      clearInterval(this.tacTimer)
    },
    getMobile() {
      let isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
      }

      if (isMobile.iOS()) {
        this.isIOS = true
      } else {
        this.isIOS = false
      }
    },
    signUp() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let account_id = this.signUpUsername 
        let password = this.signUpPassword
        let contact_phone = this.signUpUsername
        let referral_code = this.referral_code
        let affiliate_code = this.affiliate_code
        let ch = this.ch
        let cm = this.cm
        let pp = this.pp
        this.loading = true
        this.$store
          .dispatch("user/memberSignUp", { account_id, password, contact_phone, referral_code, ch, cm, pp, affiliate_code })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.countDown();
              this.step = 2
              // this.isTacPanel = true
              // this.$store.dispatch("user/updatePanel", true);
            } else {
              // this.isTacPanel = false
              // this.$store.dispatch("user/updatePanel", false);
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            if(response.status === 'affiliate_not_exists'){
              var vm = this
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "Ok",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                window.location.href = window.location.origin
              });
            }else{
              this.loading = false
              // this.isTacPanel = false
              // this.$store.dispatch("user/updatePanel", false);
              this.feedback.success = false
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
              // this.signUpLog(false, this.$t("message.list." + response.status))
              this.feedback.status = this.$t("error." + response.status)
            }
            
          });
      }
    },
    tacValidate(){
      this.$v.$touch()
      if(!this.$v.tacCode.$invalid && !this.$v.userEmail.$invalid){
        if(!this.signUpUsername){
          var account_id = this.$store.state.user.tempName;
        }else{
          var account_id = this.signUpUsername
        }
        let tac_code = this.tacCode
        let referral_code = this.referral_code
        let contact_email = this.userEmail
        this.loading = true
        this.$store
          .dispatch("user/memberTacValidate", { account_id, tac_code, referral_code, contact_email })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.clearCountDown();
              // $("#modal-register02").modal("hide");
              // $("#modal-register03").modal("show");
              // window.fbq('trackCustom', 'registersuccess', {registersuccess: 'true'});
              // this.signUpLog(true);
              this.login();
              this.reset();
              // var vm = this;
              // this.$swal({
              //   title: "Attention",
              //   text: vm.$tc('ui.signupform.account_success_first') + " " + vm.$tc('ui.signupform.account_success_second'),
              //   type: "success",
              //   allowOutSideClick: false,
              //   allowEscapeKey: false,
              //   confirmButtonText: vm.$tc('ui.login_now')
              // }).then((result)=>{
              //   vm.login()
              //   vm.reset()
              // })
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            if(response.status === 'tac_expired'){
              this.clearCountDown();
              this.tacCountDown = false
              this.tacCode = ""
            }
            this.loading = false
            this.feedback.success = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status)
            // this.signUpLog(false, this.$t("message.list." + response.status))
          });
      }
    },
    resendTacCode(){
      this.countDown();
      if(!this.signUpUsername){
        var account_id = this.$store.state.user.tempName;
      }else{
        var account_id = this.signUpUsername
      }
      this.loading = true
      this.$store
        .dispatch("user/memberRenewTac", { account_id })
        .then(response => {
          this.loading = false
          this.feedback.success = response.success
          this.feedback.status = response.status
          if (this.feedback.success == true) {
            this.$helpers.showDialog('success', this.$t('ui.tac_code_new'), "success", this);
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          this.loading = false
          this.feedback.success = false
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
          this.feedback.status = this.$t("error." + response.status)
        });
    },
    login() {
      if(!this.signUpPassword){
        var username = this.$store.state.user.tempName;
        var password = this.$store.state.user.tempPass;
      }else{
        var username = this.signUpUsername
        var password = this.signUpPassword
      }
      // this.$helpers.updateProfile({
      //   "identity": username,
      //   "phoneno" : password
      // })
      this.loading = true
      this.$store
        .dispatch("user/login", { username, password })
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success           
          if (this.feedback.success == true) {
            let refreshKey = this.$store.getters.refreshKey + 1
            this.$store.dispatch("user/setRefreshKey", refreshKey)
            // this.$store.dispatch("user/firstLogin", true)
            
            this.$store.dispatch("user/tempPass", "")
            // $("#modal-deposit").modal("show");
            // $("#modal-banner-0").modal("show");
            this.$router.push("/").catch(err => {});
            if (this.getAnnAfterLog.length > 0) {
              $("#annModal").modal("show");
            }
            if(this.currentPath === "/new-players"){
              this.$router.push("/").catch(err => {});
            }

          } else {
            var vm = this;
            if(response.status){
              this.feedback.status = this.$tc('message.list.' + response.status) 
            }
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          // if(response.status === "tac_not_validate"){
          //   this.$swal({
          //     title: vm.$tc("ui.attention"),
          //     text: vm.$tc("message.list." + response.status),
          //     type: "info"
          //   }).then(result => {
          //     // vm.$emit("triggerValidate", this.username)
          //     // this.$store.dispatch("user/updatePanel", true);
          //     this.$store.dispatch("user/tempAccName", this.username)
          //     $('#modal-login').modal('hide')
          //     $('#modal-register02').modal('show')
          //   });
          // } else {
            this.feedback.success = response.success
            var vm = this;
            var sites = ['mseric1', 'mseric2', 'epicvip', 'epicinfinity', 'epicwin2']
            if(sites.includes(response.status)){
              this.feedback.status = this.$tc("message.wrong_site.description") + this.$tc("message.wrong_site." + response.status)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "Proceed",
                text: vm.$tc("message.wrong_site.description") + vm.$tc("message.wrong_site." + response.status) + ". Click 'Proceed' button will redirect you to the site",
                type: "info"
              }).then(result => {
                window.location.href = vm.$tc("message.url."+ response.status)
              });
            }else{
              if(response.status){
                this.feedback.status = this.$tc('message.list.' + response.status) 
              }
              // var loginInfo = {
              //   "identity": this.username,
              //   "status":"failed",
              //   "platform": "Web",
              //   "remark": this.$tc("message.list."+response.status),
              //   "actionDate": this.$moment().format("DD/MM/YYYY"),
              //   "actionTime": this.$moment().format("HH:mm:ss"),
              //   "balance": "-",
              //   "loyaltyRank": "-",
              //   "loyaltyPoints": "-",
              //   "preferredLanguage": this.$tc("ui.ct."+this.$store.getters.language)
              // }
              // this.$helpers.loginLog(loginInfo);
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
            }
          // }
        });
    },
    // getRoyaltyLevel(id){
    //   let url = `https://evvtff.ibacktech889.com/LoyaltyProgram/api/GetPlayerInfoForOp?playerId=${id}`
    //   // var json = {
    //   //   app_id : config.app_id
    //   // }
    //   this.$http.get(url).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.status == "200";
    //           } else {
    //             this.feedback.success = response.status == 200;
    //           }

    //           this.feedback.status = response.status;
    //           if (this.feedback.success == true) {
    //             this.$store.dispatch("user/setRoyaltyLevel", response.data.Progress.RankId)
    //           } else {
    //           }
    //         }
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     },
    //   );
    // },
    // signUpLog(status, message){
    //   if(status){
    //     var statusCode = "success"
    //     var remark = "-"
    //   }else{
    //     var statusCode = "failed"
    //     var remark = message
    //   }
    //   if(!this.signUpUsername){
    //     var account_id = this.$store.state.user.tempName;
    //   }else{
    //     var account_id = this.prefix + this.signUpUsername
    //     }
    //   var ctData = {
    //     "identity": account_id,
    //     "status": statusCode,
    //     "platform": "Web",
    //     "parentId": config.app_id,
    //     "actionDate": this.$moment().format("DD/MM/YYYY"),
    //     "actionTime": this.$moment().format("HH:mm:ss"),
    //     "referrerCode": this.referral_code,
    //     "remark": remark,
    //   }
    //   this.$helpers.signUpLog(ctData)
    // },
    reset(){
      this.$store.dispatch("user/tempAccName", "")
      this.$store.dispatch("user/tempPass", "")
      this.clearCountDown();
      this.tacCountDown = false;
      this.tacCode = ""
      this.userEmail = ""
      this.emailChecked = false
      this.signUpPassword = ""
      this.signUpUsername = ""
      this.$v.$reset()
    }
  }
};
</script>
<style lang="scss" scoped>
.disabled-grey{
  background: #DEDEDE;
  color: #FFFFFF;
  pointer-events: none;
}
.modal-livechat-btn{
  width: 100% !important;
  height: 100% !important;
}
.custom-font-size{
  font-size: 17px !important;
}
.prefix{
  appearance: auto !important;
  color: #ffffff;
  background-color: #420278;
  border: none;
}
</style>